<template>
    <div class="cert-filters">
        <label class="cert-filters__search">
            <v-icon size="20" aria-hidden="true">mdi-magnify</v-icon>
            <input
                :value="query"
                type="search"
                :placeholder="$t('student.certificates.searchByCourse')"
                :aria-label="$t('student.certificates.searchByCourse')"
                @input="$emit('update:query', $event.target.value)"
            />
        </label>

        <label class="cert-filters__select">
            <v-icon size="18" aria-hidden="true">mdi-calendar-blank-outline</v-icon>
            <select
                :value="period"
                :aria-label="$t('student.filters.period')"
                @change="onPeriodChange"
            >
                <option
                    v-for="option in periodOptions"
                    :key="String(option.value)"
                    :value="option.value"
                >
                    {{ option.label }}
                </option>
            </select>
        </label>

        <label class="cert-filters__select">
            <v-icon size="18" aria-hidden="true">mdi-clock-outline</v-icon>
            <select
                :value="status"
                :aria-label="$t('common.status')"
                @change="$emit('update:status', $event.target.value)"
            >
                <option
                    v-for="option in statusOptions"
                    :key="option.value"
                    :value="option.value"
                >
                    {{ option.label }}
                </option>
            </select>
        </label>

        <button
            type="button"
            class="cert-filters__clear"
            :disabled="!hasActiveFilters"
            @click="$emit('clear')"
        >
            <v-icon size="18" aria-hidden="true">mdi-filter-off-outline</v-icon>
            {{ $t('student.certificates.clearFilters') }}
        </button>
    </div>
</template>

<script>
    export default {
        name: 'CertificateFilters',
        props: {
            query: { type: String, default: '' },
            period: { type: [String, Number], default: 'all' },
            status: { type: String, default: 'all' },
            periodOptions: { type: Array, default: () => [] },
            statusOptions: { type: Array, default: () => [] },
            hasActiveFilters: { type: Boolean, default: false },
        },
        emits: ['update:query', 'update:period', 'update:status', 'clear'],
        methods: {
            onPeriodChange(event) {
                const value = event.target.value;
                this.$emit('update:period', value === 'all' ? 'all' : Number(value));
            },
        },
    };
</script>

<style scoped>
    .cert-filters {
        display: grid;
        grid-template-columns: minmax(240px, 1.7fr) 180px 180px auto;
        gap: 10px;
        align-items: center;
    }

    .cert-filters__search,
    .cert-filters__select {
        display: flex;
        align-items: center;
        gap: 8px;
        min-width: 0;
        height: 40px;
        padding: 0 12px;
        border: 1px solid var(--certs-line, #e6e8ee);
        border-radius: 10px;
        background: var(--certs-surface, #fff);
        color: var(--certs-muted, #6b7280);
    }

    .cert-filters__search input,
    .cert-filters__select select {
        width: 100%;
        min-width: 0;
        border: 0;
        outline: 0;
        background: transparent;
        color: var(--certs-text, #111827);
        font-size: 0.875rem;
    }

    .cert-filters__select select {
        cursor: pointer;
    }

    .cert-filters__clear {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        height: 40px;
        padding: 0 12px;
        border: 1px solid var(--certs-line, #e6e8ee);
        border-radius: 10px;
        background: var(--certs-surface, #fff);
        color: var(--certs-text, #374151);
        font-weight: 600;
        font-size: 0.84rem;
        cursor: pointer;
        white-space: nowrap;
    }

    .cert-filters__clear:disabled {
        opacity: 0.45;
        cursor: not-allowed;
    }

    .cert-filters__search:focus-within,
    .cert-filters__select:focus-within,
    .cert-filters__clear:focus-visible {
        outline: 2px solid var(--certs-accent, #1ac4cd);
        outline-offset: 2px;
    }

    @media (max-width: 860px) {
        .cert-filters {
            grid-template-columns: 1fr;
        }

        .cert-filters__clear {
            width: 100%;
        }
    }
</style>
